import { AddRounded, KeyboardArrowDownRounded } from "@mui/icons-material";
import {
  Autocomplete,
  createFilterOptions,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import React from "react";
import highlightMatch from "../utils/highlightMatch";
import { useEffect } from "react";
import { useState } from "react";
const filter = createFilterOptions();

export default function InputAuto(props) {
  const {
    name,
    label,
    value,
    variant,
    size,
    onChange,
    onInput,
    options = [],
    error = null,
    required,
    placeholder,
    enableAddBtn = false,
    handleAdd,
    disableClearable = true,
    noFilter = false,
    loading = false,
    // Optional (opt) => ReactNode replacing the plain grey subtitle line, for
    // pickers whose secondary text carries meaning rather than just context —
    // the POS supplier picker paints an outstanding balance red with it.
    //
    // Destructured rather than left in `...other` on purpose: renderOption is
    // declared AFTER the `{...other}` spread below, so a caller could never have
    // overridden it, and letting an unknown function prop reach the Autocomplete
    // would land it on the DOM node and warn.
    renderSubtitle,
    ...other
  } = props;
  const [val, setVal] = useState(null);

  useEffect(() => {
    setVal(options.find((j) => j.id === value));
  }, [options, value]);

  // Only a non-empty STRING subtitle is appended. An endpoint that projects an
  // entity into `subtitle` used to take the whole screen down here with
  // "opt.subtitle.trim is not a function"; a shared control should degrade, not
  // crash, when one caller sends the wrong shape.
  const getLabel = (opt) => {
    if (!opt || typeof opt === "string" || opt.inputValue) return "";
    const sub = typeof opt.subtitle === "string" ? opt.subtitle.trim() : "";
    return `${opt.label ?? ""}${sub ? ` (${sub})` : ""}`;
  };

  const handleChange = (even, newVal) => {
    if (newVal && newVal.inputValue) handleAdd(newVal.inputValue);
    else {
      setVal(newVal);
      var e = {
        target: {
          value: newVal ? newVal.id : "",
          name: name,
        },
      };
      onChange && onChange(e, newVal);
    }
  };

  const handleInpChg = (even, newVal, reason) => {
    if (!newVal) {
      setVal(null);
      handleChange(null, newVal);
    }
    onInput && onInput(even, newVal, reason);
  };

  const handleFilterOpt = (opt, params) => {
    const filtered = noFilter ? [...opt] : filter(options, params);
    if (enableAddBtn && params.inputValue !== "") {
      filtered.push({
        inputValue: params.inputValue,
        label: (
          <div className="text-red-500 flex gap-2 items-center primary-color fs-[18px]">
            <AddRounded className="!text-[20px]" /> Add{" "}
            <span className="font-medium">"{params.inputValue}"</span>
          </div>
        ),
      });
    }
    return filtered;
  };

  return (
    <Autocomplete
      data-field={name}
      disableClearable={disableClearable}
      autoHighlight
      loading={loading}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      options={options}
      value={val || null}
      size={size || "small"}
      onChange={handleChange}
      onInputChange={handleInpChg}
      {...other}
      getOptionLabel={getLabel}
      filterOptions={handleFilterOpt}
      renderOption={(prop, opt, state) => {
        // The typed text, marked in each row as the POS item search does. Not when it
        // is just the selected option's own label (a filled box reopened) — that would
        // paint the whole row and explain nothing. Only plain strings are marked: the
        // "+ Add" row's label is an element.
        const q =
          val && state?.inputValue === getLabel(val) ? "" : state?.inputValue || "";
        const mark = (text) => (typeof text === "string" ? highlightMatch(text, q) : text);
        return (
          <ListItemButton
            {...prop}
            key={`${opt.id}-${opt.label}`}
            sx={{
              p: 0,
              mb: "2px",
              minHeight: "auto",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontSize: "14px",
                color: "#333",
              }}
              secondaryTypographyProps={{
                fontSize: "12px",
                color: "#777",
                // component="div" so a custom renderSubtitle may return an element;
                // the default <p> would make a nested block invalid markup.
                component: "div",
              }}
              sx={{ m: 0 }}
              primary={mark(opt.label)}
              secondary={
                renderSubtitle
                  ? renderSubtitle(opt)
                  : typeof opt.subtitle === "string"
                  ? mark(opt.subtitle)
                  : null
              }
            />
          </ListItemButton>
        );
      }}
      componentsProps={{
        paper: {
          className: "border border-gray-500 !rounded-[10px]",
        },
      }}
      popupIcon={<KeyboardArrowDownRounded />}
      renderInput={(params) => (
        <TextField
          variant={variant || "outlined"}
          label={label}
          required={required}
          placeholder={placeholder}
          {...params}
          {...(error && { error: true, helperText: error })}
        />
      )}
    />
  );
}
